/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {SessionService} from "../../../platform/base/services/session.service";
import {TranslateService} from "@ngx-translate/core";
import {IAccountModel} from "../../../../../types/platform/server";
import {AuthLevel} from "../../../../../types/aig/universe";

import {GuestsService} from "../../guests/guests.service";
import {Guests2Service} from "../../guests2/guests2.service";

/**
 * todo
 */
@Component({
	selector: 'belongs-panel',
	templateUrl: './belongs-panel.component.html',
	styleUrls: ['./belongs-panel.component.css']
})
export class BelongsPanelComponent implements OnInit, OnChanges {

	@Input() public auth: any;
	@Input() public account: any;

	public belongs_user: IAccountModel[] = [];

	/**
	 * @param session
	 * @param accountService
	 * @param translate
	 */
	constructor(
		protected session: SessionService,
		protected accountService: GuestsService,
		//protected accountService: Guests2Service,		// todo:guests2
		public translate: TranslateService
	) {
	}

	/**
	 * @returns none
	 */
	public ngOnChanges(changes: any): void {
		this.belongs();
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		this.belongs();
	}

	/**
	 * @returns none
	 */
	public onUpdate(): void {
		this.belongs();
	}

	/**
	 * @returns none
	 */
	private belongs(): void {
		this.accountService.belongs(this.account?.user_id, (error: any, belongs: []) => {
			if (!error) {
				const map: any = {};
				belongs.forEach((account: any) => {
					map[account.user_id] = account;
				});
				this.belongs_user = Object.values(map);
			}
		})
	}

	/**
	 * @returns none
	 */
	public authIs(level: string): boolean {
		let result: boolean = false;     // public
		switch (level) {
			case "system":
				result = (this.auth <= AuthLevel.system);
				break;
			case "manager":
				result = (this.auth <= AuthLevel.manager);
				break;
			case "company":
				result = (this.auth <= AuthLevel.company);
				break;
			case "studio":
				result = (this.auth <= AuthLevel.studio);
				break;
			case "trainer":
				result = (this.auth <= AuthLevel.trainer);
				break;
			case "user":
				result = (this.auth <= AuthLevel.user);
				break;
			case "public":
				result = (this.auth <= AuthLevel.public);
				break;
			default:
		}
		return result;
	}

	/**
	 * @returns style
	 */
	public paymentStyle(user: any): any {
		let result: any = {
			"font-weight": 500,
			color: "#8080d7"
		};
		if (user.content?.accounting) {
			result = {
				"font-weight": 900,
				color: "#d7808a"
			};
		}
		return result;
	}

}
